<div class="flex items-center justify-start gap-1 rounded-lg md:gap-3">
    <div class="max-w-2/5 text-sm">
        <app-link [link]="'/knowledge'">
            <div
                class="w-full truncate py-4 font-heading text-xs uppercase tracking-widest text-link-blue transition duration-200 ease-in-out hover:text-link-blue">
                Guides
            </div>
        </app-link>
    </div>
    <div class="w-2 text-black">
        <svg
            viewBox="0 0 6 7"
            class="stroke-current"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1 1L5 3.5L1 6"
                stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>
    </div>
    <div class="max-w-2/5 text-sm">
        <app-link [link]="'/knowledge/category/' + destination?.urlSlug">
            <div
                class="w-full truncate py-4 font-heading text-xs uppercase tracking-widest text-link-blue transition duration-200 ease-in-out hover:text-link-blue">
                {{ destination?.name }}
            </div>
        </app-link>
    </div>
    <div class="w-2 text-black">
        <svg
            viewBox="0 0 6 7"
            class="stroke-current"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1 1L5 3.5L1 6"
                stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>
    </div>
    <div class="max-w-1/3 text-sm md:max-w-2/5">
        <app-link [link]="'/knowledge/' + article?.urlSlug">
            <div
                class="w-full truncate py-4 font-heading text-xs uppercase tracking-widest text-link-blue transition duration-200 ease-in-out hover:text-link-blue">
                {{ article?.shortTitle }}
            </div>
        </app-link>
    </div>
    <app-json-ld [json]="seoBreadCrumbs"></app-json-ld>
</div>
